/* eslint-disable react/prop-types */
import { Location, Profile } from 'iconsax-react';
import { Link } from 'react-router-dom';
import perfil from '../../../../assets/images/not-photo.png';
import noverif from '../../../../assets/images/not-verification.svg';
import verif from '../../../../assets/images/verification.svg';
import Text from '../../../../assets/styles/Text';
import calculateAge from '../../../../utils/calculateAge';
import * as styles from './styles';

export default function Banner({ client = {} }) {
  return (
    <styles.Container>
      {client && (
        <>
          <styles.WrapImg>
            <img
              src={client.profilePhoto || perfil}
              alt="perfil"
              className="perfil"
            />

            <img
              src={client.verification ? verif : noverif}
              alt="verification"
              className="verification"
            />
          </styles.WrapImg>
          <styles.Group>
            <styles.Top>
              <div>
                <Text.H1 $bold>{client.name || 'Adicione seu nome'}</Text.H1>

                {client?.city && (
                  <div>
                    <Location size={24} />
                    <Text.P $bold>
                      {client.city.name} - {client.city.stateAc}
                    </Text.P>
                  </div>
                )}

                {client?.dateOfBirth && (
                  <div>
                    <Profile size={24} />
                    <Text.P $bold>
                      {calculateAge(client.dateOfBirth)} anos
                    </Text.P>
                  </div>
                )}
              </div>

              <Link to="/clientdescription">
                <Text.P $bold>Editar Perfil</Text.P>
              </Link>
            </styles.Top>

            <Text.P>{client.description || 'Adicione sua descrição'}</Text.P>
          </styles.Group>
        </>
      )}
    </styles.Container>
  );
}
